import React, { useState, useEffect } from "react";
import Select from "react-select";
import CustomDatePicker from "./Custom-Datepicker";
import { FaSpinner } from "react-icons/fa";
import { Modal, Button, Table } from "react-bootstrap";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import moment from "moment";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import * as Yup from "yup";

const customStyle = {
  control: (provided, state) => ({
    ...provided,
    height: "64px",
    overflow: "scroll",
  }),
  multiValueRemove: (base, state) => ({
    ...base,
    color: "white",
    ":hover": {
      backgroundColor: "red",
      color: "white",
    },
  }),
};

const CreateProjectAdd = () => {
  const initialFormData = {
    ClientID: null,
    Name: "",
    ProjectType: null,
    Billable: null,
    ProjectLocation: null,
    Technologies: [],
    StartDate: "",
    EndDate: "",
    DaysOrMonth: "",
    PaymentTerms: "",
    POValue: "",
    TNEInvoice: "",
    Currency: null,
    FixedBid: null,
    Description: "",
    Rate: "",
    projectinvoice: [],
    projectmilestone: [],
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateNavbarHeading("Create Project"));
  }, []);

  const [loading, setLoading] = useState(false);
  const [showSOWModal, setShowSOWModal] = useState(false);
  const [showFixedBidModal, setShowFixedBidModal] = useState(false);
  const [apiStatus, SetApiStatus] = useState(undefined);
  const [clientNameOptions, setClientNameOptions] = useState([]);
  const [projectTypeOptions, setProjectTypeOptions] = useState([]);
  const [billableOptions, setBillableOptions] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [fixedBidOptions, setFixedBidOptions] = useState([
    { value: 0, label: "-Select Bid-" },
    { value: 1, label: "Yes" },
  ]);
  const [technoOptions, setTechnologyOptions] = useState([]);
  const [formData, setFormData] = useState(initialFormData);
  const [sowLines, setSowLines] = useState(formData?.projectinvoice);
  const [errors, setErrors] = useState({});

  const [sowErrors, setSowErrors] = useState({}); // Separate state for errors
  const [sowTypesOptions, setSOWTypesOptions] = useState([]);
  const [fixesBidLines, setFixedBidLines] = useState(
    formData?.projectmilestone || []
  );
  const [milestoneErrors, setMilestoneErrors] = useState({});
  const [clientFetchData, setClientFetchData] = useState([]);
  const sowLinesSchema = Yup.object().shape({
    InvoiceNo: Yup.string().required("SOW/PO/SO is required"),
    StartDate: Yup.string().required("Start date is required"),
    EndDate: Yup.string().nullable(), // EndDate can be empty
    ProposalType: Yup.mixed().nullable(),
        SoPoBalance: Yup.string().nullable(), // EndDate can be empty
        SoPoValue: Yup.string().nullable(), // EndDate can be empty
        SoPoRemark: Yup.string().nullable(), // EndDate can be empty
  });

  const milestoneSchema = Yup.object().shape({
    Milestone: Yup.string().required("Milestone is required"),
    // Add other milestone fields if needed
  });

  const schema = Yup.object().shape({
    ClientID: Yup.number()
      .typeError("Client is required")
      .required("Client is required"),
    Name: Yup.string().required("Name is required"),
    ProjectType: Yup.number()
      .typeError("Project Type is required")
      .required("Project Type is required"),
    Billable: Yup.number()
      .typeError("Billable is required")
      .required("Billable is required"),
    ProjectLocation: Yup.number()
      .typeError("Location is required")
      .required("Location is required"),
    Technologies: Yup.array()
      .of(
        Yup.object().shape({
          value: Yup.number().required("Technology value is required"),
          label: Yup.string().required("Technology label is required"),
        })
      )
      .min(1, "Please select at least one technology")
      .required("Technologies are required"),
    StartDate: Yup.string().required("Start Date is Required"),
    EndDate: Yup.string().nullable(),
    DaysOrMonth: Yup.string().nullable(),
    PaymentTerms: Yup.string().required("Payment Term is required"),
    // Modified POValue validation
    // POValue: Yup.string().when("FixedBid", {
    //   is: (val) => val === 1, // Only validate when FixedBid is 1
    //   then: (schema) => schema.required("PO Value is required "),
    //   otherwise: (schema) => schema.nullable(),
    // }),
    TNEInvoice: Yup.mixed().nullable(),
    Currency: Yup.number()
      .typeError("Currency is required")
      .required("Currency is required"),

    FixedBid: Yup.number().typeError("Must be a number").nullable(), // Makes the field optional

    // projectmilestone validation (only when FixedBid === 1)
    projectmilestone: Yup.array()
      .of(milestoneSchema)
      .when("FixedBid", {
        is: (val) => val === 1, // Only validate when FixedBid is exactly 1
        then: (schema) =>
          schema.min(
            1,
            "At least one milestone is required"
          ),
        otherwise: (schema) => schema.notRequired(),
      }),

    // projectinvoice validation (always required with at least one item)
    projectinvoice: Yup.array()
      .of(sowLinesSchema)
      .min(1, "At least one SOW/PO/SO is required"),

    Description: Yup.string().nullable(),
    Rate: Yup.string().nullable(),
    // Removed duplicate Rate field
  });
  // Validate individual field
  const validateField = async (fieldName, updatedData) => {
    try {
      await schema.validateAt(fieldName, updatedData);
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
    } catch (err) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: err.message,
      }));

      if (fieldName.startsWith("lines")) {
        toast.error(err.message, { position: "top-right" });
      }
    }
  };

  const validateSowField = async (fieldName, value) => {
    try {
      await sowLinesSchema.validateAt(fieldName, { [fieldName]: value });

      setSowErrors((prevErrors) => {
        const { [fieldName]: _, ...newErrors } = prevErrors; // ✅ Remove error if valid
        return newErrors;
      });
    } catch (err) {
      setSowErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: err.message, // ✅ Store error without index
      }));
      toast.error(err.message, { position: "top-right" });
    }
  };

  const handleSowModal = (e) => {
    e.preventDefault();
    setShowSOWModal(true);
  };
  const handleSOWClose = () => {
    setShowSOWModal(false);
    setSowLines(formData?.projectinvoice);
  };

  const handleFixedBid = (e) => {
    setShowFixedBidModal(true);
    e.preventDefault();
  };

  const handleFixedBidClose = () => {
    setShowFixedBidModal(false);
  };

  useEffect(() => {
    fetchIndexData();
  }, []);
  const [projectOptions, setProjectOptions] = useState([])
  console.log("projectOptions", projectOptions);

  const fetchIndexData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/project-getdata`
      );

      SetApiStatus(response?.status);
      if (response?.status === 200) {
        const fetchData = response?.data?.data;
        const projOpt = fetchData?.allprojectlist;
        setProjectOptions(projOpt);
        const clientOpt = fetchData?.clientname?.map((ele, inded) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setClientNameOptions(clientOpt);

        const projectTypeOpt = fetchData?.projectallocationtype?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));

        setProjectTypeOptions(projectTypeOpt);

        const billableOpt = fetchData?.billable?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));

        setBillableOptions(billableOpt);
        const locationOpt = fetchData?.locationlist?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));

        setLocationOptions(locationOpt);
        const currenOpt = fetchData?.currency?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));

        setCurrencyOptions(currenOpt);

        const technoOpt = fetchData?.technologylist?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setTechnologyOptions(technoOpt);
        const proposalOpt = Object.entries(fetchData?.proposal || {}).map(
          ([key, value]) => ({
            value: key,
            label: value,
          })
        );

        setSOWTypesOptions(proposalOpt);
      } else {
        console.error(
          "Failed to fetch asset categories. Server responded with status:",
          response
        );
      }
    } catch (error) {
      console.console.error("Api Error Create Project Add", error);
    }
  };
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);

  const handleChange = async (e) => {
    const { name, value } = e.target;
    if (name === "Name") {
      // Filter suggestions that match input
      const matchedSuggestions = projectOptions.filter((suggestion) =>
        suggestion.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredSuggestions(matchedSuggestions);
      setShowSuggestions(value.length > 0 && matchedSuggestions.length > 0);
    }
    // Update form data only for fields in the schema
    if (schema.fields[name]) {
      setFormData((prevData) => {
        const updatedData = { ...prevData, [name]: value };
        validateField(name, updatedData);
        return updatedData;
      });
    }
  };

  const handleSelectChange = async (selectedOption, name) => {
    // Update formData with the selected value for the SkillID
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: selectedOption.value };
      // Trigger validation for the specific field after updating
      validateField(name, updatedData);
      return updatedData;
    });
  };

  const handleFixedBidAddLine = () => {
    if (
      fixesBidLines.length === 0 ||
      fixesBidLines[fixesBidLines.length - 1].Milestone?.trim()
    ) {
      setFixedBidLines((prevLines) => [
        ...prevLines,
        {
          LineNo: prevLines.length + 1,
          Milestone: null,
          StartDate: "",
          EndDate: "",
          Remarks: "",
          MilestoneValue: 0,
        },
      ]);
    } else {
      toast.error("Milestone is required before adding a new line.", {
        position: "top-right",
      });
    }
  };

  const handleMileStoneChange = async (e, index) => {
    const { name, value } = e.target;

    setFixedBidLines((prevLines) =>
      prevLines.map((row, idx) =>
        idx === index ? { ...row, [name]: value } : row
      )
    );

    if (name === "Milestone") {
      await validateMilestoneField(value, index);
    }
  };

  const validateMilestoneField = async (value, index) => {
    try {
      await milestoneSchema.validate({ Milestone: value });

      setMilestoneErrors((prevErrors) => {
        const { [`Milestone-${index}`]: _, ...newErrors } = prevErrors;
        return newErrors;
      });
    } catch (error) {
      setMilestoneErrors((prevErrors) => ({
        ...prevErrors,
        [`Milestone-${index}`]: error.message,
      }));
      toast.error(error.message, { position: "top-right" });
    }
  };

  const addMilestoneToInvoice = async () => {
    if (fixesBidLines.length === 0) {
      toast.error("At least one milestone record is required before saving.", {
        position: "top-right",
      });
      return;
    }

    try {
      await Promise.all(
        fixesBidLines.map((row) =>
          milestoneSchema.validate(row, { abortEarly: false })
        )
      );

      setMilestoneErrors({});
      setShowFixedBidModal(false);

      setFormData((prevFormData) => ({
        ...prevFormData,
        projectmilestone: fixesBidLines,
      }));
    } catch (error) {
      if (error.inner) {
        const newErrors = error.inner.reduce((acc, err) => {
          acc[err.path] = err.message;
          return acc;
        }, {});

        setMilestoneErrors(newErrors);
      }
    }
  };

  const handleDeleteMilestoneLine = (index) => {
    setFixedBidLines((prevLines) =>
      prevLines.filter((_, idx) => idx !== index)
    );

    setMilestoneErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[`Milestone`];
      return newErrors;
    });
  };

  const handleSowAddLine = () => {
    if (
      sowLines.length === 0 ||
      (sowLines[sowLines.length - 1].InvoiceNo?.trim() &&
        sowLines[sowLines.length - 1].StartDate?.trim())
    ) {
      setSowLines((prevSowLines) => [
        ...prevSowLines,
        {
          LineNo: prevSowLines.length + 1,
          ProposalType: null,
          InvoiceNo: "",
          StartDate: "",
          EndDate: "",
          SoPoValue: null,
          SoPoBalance: null,
          SoPoRemark: null,
        },
      ]);
    } else {
      toast.error(
        "Invoice No. and Start Date are required before adding a new line.",
        { position: "top-right" }
      );
    }
  };

  const handleProjectInvoiceChange = async (e, index) => {
    const { name, value } = e.target;

    setSowLines((prevSowLines) =>
      prevSowLines.map((row, idx) =>
        idx === index ? { ...row, [name]: value } : row
      )
    );

    if (["InvoiceNo", "StartDate"].includes(name)) {
      await validateSowField(name, value);
    }
  };

  const [sowIndex, setSowIndex] = useState(0);

  const handleProjectInvoiceSelectChange = async (
    selectedOption,
    name,
    index
  ) => {
    // Format the current date as DD-MM-YYYY
    const now = new Date();
    const formattedDate = moment(now).format("DDMMMYYYY");

    setSowLines((prevSowLines) => {
      // Count how many SOW entries exist already
      const currentSowCount = prevSowLines.filter((line) =>
        line.InvoiceNo?.startsWith("SOW")
      ).length;

      return prevSowLines.map((row, idx) =>
        idx === index
          ? {
            ...row,
            [name]: selectedOption?.value,
            InvoiceNo:
              selectedOption?.label === "SOW"
                ? `SOW_${formattedDate}_${currentSowCount + 1}`
                : "",
          }
          : row
      );
    });

    if (["ProposalType"].includes(name)) {
      await validateSowField("InvoiceNo", selectedOption?.label);
    }
  };
  const AddSowToInvoice = async () => {
    if (sowLines.length === 0) {
      toast.error("At least one record is required before saving.", {
        position: "top-right",
      });
      return;
    }

    try {
      await Promise.all(
        sowLines.map((row) =>
          sowLinesSchema.validate(row, { abortEarly: false })
        )
      );

      setSowErrors({});
      setShowSOWModal(false);
      // toast.success("All fields are valid!", { position: "top-right" });

      setFormData((prevFormData) => ({
        ...prevFormData,
        StartDate: sowLines?.length
          ? sowLines[0].StartDate
          : null,
        projectinvoice: sowLines,
        EndDate: sowLines?.length
          ? sowLines[sowLines.length - 1].EndDate
          : null,
      }));

      validateField("projectinvoice", sowLines);
    } catch (error) {
      if (error.inner) {
        const newErrors = error.inner.reduce((acc, err) => {
          if (err.path && ["InvoiceNo", "StartDate"].includes(err.path)) {
            acc[err.path] = err.message;
          }
          return acc;
        }, {});

        setSowErrors(newErrors);
      }
    }
  };

  const handleDeleteLine = (index) => {
    setSowLines((prevSowLines) =>
      prevSowLines.filter((_, idx) => idx !== index)
    );

    setSowErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors["InvoiceNo"];
      delete newErrors["StartDate"];
      return newErrors;
    });
  };

  const handleTechnologyChange = async (selectedOptions) => {
    const selectedTechnologies = selectedOptions || [];

    // Prepare updated form data with new Technologies
    const updatedFormData = {
      ...formData,
      Technologies: selectedTechnologies,
    };

    setFormData(updatedFormData);

    // Call validateField with correct updated data
    validateField("Technologies", updatedFormData);
  };

  const fetchClientDetails = async (clientid) => {
    try {
      let response = await GetServiceCaller(
        `${API_URL}projectmanagement/employee-client-details?clientID=${clientid}`
      );

      if (response?.status === 200) {
        setClientFetchData(response?.data?.data);
      }
    } catch (error) {
      console.error("FEtching APi  Error ", error);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // First check if projectInvite array is empty
      // if (!formData?.projectinvoice || formData.projectinvoice.length === 0) {
      //   toast.error("Please add at least one SOW/PO/SO");
      //   return; // Exit the function early
      // }

      // Validate formData using schema
      await schema.validate(formData, { abortEarly: false });
      setErrors({}); // Clear previous errors

      const response = await PostServiceCaller(
        `${API_URL}projectmanagement/project-listingdata`,
        formData,
        "post"
      );

      if (response?.status === 200) {
        toast.success("Data submitted successfully");

        // Redirect after successful submission
        setTimeout(() => {
          navigate(`/create-project/edit/${response?.data?.ID}`);
        }, 4000);
      } else {
        console.error(
          "Failed to submit data. Server responded with status:",
          response?.status
        );
        toast.error("Failed to submit data. Please try again.");
      }
    } catch (error) {
      if (error?.name === "ValidationError") {
        console.error("Validation Error:", error);

        const validationErrors = {};
        error.inner?.forEach((err) => {
          validationErrors[err.path] = err.message;
        });

        setErrors(validationErrors);
        // toast.error("Validation failed. Please check your inputs.");
      } else {
        console.error("Unexpected Error:", error);
        toast.error("Something went wrong. Please try again later.");
      }
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {
  const handleClickOutside = (event) => {
    const suggestionsElement = document.querySelector(".suggestions-container");
    const inputElement = document.getElementById("Name");

    if (
      showSuggestions &&
      suggestionsElement &&
      !suggestionsElement.contains(event.target) &&
      inputElement !== event.target
    ) {
      setShowSuggestions(false);
    }
  };

  // ✅ Add event listener
  document.addEventListener("mousedown", handleClickOutside);

  // ✅ Cleanup
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [showSuggestions]);

  return (
    <>
      <div className="Container">
        <form
          //   onSubmit={handleSubmit}
          id="formOne"
          className="rounded mt-2 bg-white"
        >
          <div className="mx-2">
            <div className="row row-flex">
              <div className="col-md-12 flex-col">
                <div className="card-body">
                  <div className="row mt-2">
                    <div className="col-2">
                      <label className="form-label">
                        Client<span className="text-danger">*</span>
                      </label>
                      <Select
                        name="ClientID"
                        className={` ${errors.ClientID ? "is-invalid" : ""}`}
                        onChange={(selectedOption, action) => {
                          handleSelectChange(selectedOption, action.name);
                          fetchClientDetails(selectedOption.value);
                        }}
                        value={clientNameOptions?.find(
                          (o) => o.value === formData?.ClientID
                        )}
                        options={clientNameOptions}
                      />
                      {errors.ClientID && (
                        <div className="invalid-feedback">
                          {errors.ClientID}
                        </div>
                      )}
                    </div>
                    <div className="col-2">
                      <label className="form-label">CP</label>
                      <input
                        type="text"
                        className="form-control"
                        name="CP"
                        disabled
                        value={clientFetchData[0]?.CP_Name}
                      />
                    </div>
                    <div className="col-2">
                      <label className="form-label">DP</label>
                      <input
                        type="text"
                        className="form-control"
                        name="DP"
                        disabled
                        value={clientFetchData[0]?.DP_Name}
                      />
                    </div>
                    <div className="col-2">
                      <label className="form-label">PM</label>
                      <input
                        type="text"
                        className="form-control"
                        name="PM"
                        disabled
                        value={clientFetchData[0]?.PM_Name}
                      />
                    </div>
                    <div className="col-2" style={{ position: "relative" }}>
                      <label className="form-label">
                        Project Name<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${errors.Name ? "is-invalid" : ""}`}
                        name="Name"
                        value={formData?.Name}
                        onChange={handleChange}
                      />

                      {showSuggestions && filteredSuggestions.length > 0 && (
                        <div
                          className="suggestions-container"
                          style={{
                            position: "absolute",
                            width: "100%", // Match input width
                            maxHeight: "200px",
                            overflowY: "auto",
                            backgroundColor: "#fff",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            zIndex: 1000,
                            marginTop: "2px",
                          }}
                        >
                          <div
                            style={{
                              padding: "8px 12px",
                              fontSize: "0.8rem",
                              color: "#666",
                              borderBottom: "1px solid #eee",
                              backgroundColor: "#f8f9fa",
                            }}
                          >
                            Existing matching Project Name:
                          </div>
                          <ul
                            style={{
                              listStyle: "none",
                              padding: 0,
                              margin: 0,
                            }}
                          >
                            {filteredSuggestions.map((suggestion, index) => (
                              <li
                                key={index}
                                style={{
                                  padding: "8px 12px",
                                  fontSize: "0.9rem",
                                  borderBottom: "1px solid #eee",
                                  color: "#333",
                                  cursor: "default",
                                }}
                              >
                                {suggestion}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}

                      {errors.Name && (
                        <div className="invalid-feedback">{errors.Name}</div>
                      )}
                    </div>

                    <div className="col-2">
                      <label className="form-label">
                        Project Type<span className="text-danger">*</span>
                      </label>
                      <Select
                        name="ProjectType"
                        className={` ${errors.ProjectType ? "is-invalid" : ""}`}
                        onChange={(selectedOption, action) =>
                          handleSelectChange(selectedOption, action.name)
                        }
                        value={projectTypeOptions?.find(
                          (o) => o.value === formData?.ProjectType
                        )}
                        options={projectTypeOptions}
                      />
                      {errors.ProjectType && (
                        <div className="invalid-feedback">
                          {errors.ProjectType}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-2">
                      <label className="form-label">
                        Billable<span className="text-danger">*</span>
                      </label>
                      <Select
                        name="Billable"
                        className={` ${errors.Billable ? "is-invalid" : ""}`}
                        onChange={(selectedOption, action) =>
                          handleSelectChange(selectedOption, action.name)
                        }
                        value={billableOptions?.find(
                          (o) => o.value === formData?.Billable
                        )}
                        options={billableOptions}
                      />
                      {errors.Billable && (
                        <div className="invalid-feedback">
                          {errors.Billable}
                        </div>
                      )}
                    </div>
                    <div className="col-2">
                      <label className="form-label">
                        Location<span className="text-danger">*</span>
                      </label>
                      <Select
                        name="ProjectLocation"
                        className={` ${errors.ProjectLocation ? "is-invalid" : ""
                          }`}
                        onChange={(selectedOption, action) =>
                          handleSelectChange(selectedOption, action.name)
                        }
                        value={locationOptions?.find(
                          (o) => o.value === formData?.ProjectLocation
                        )}
                        options={locationOptions}
                      />
                      {errors.ProjectLocation && (
                        <div className="invalid-feedback">
                          {errors.ProjectLocation}
                        </div>
                      )}
                    </div>
                    <div className="col-2">
                      <label className="form-label">Technology<span className="text-danger">*</span></label>
                      <Select
                        isMulti
                        className={` ${errors.Technologies ? "is-invalid" : ""
                          }`}
                        name="Technologies"
                        options={technoOptions}
                        styles={customStyle}
                        onChange={handleTechnologyChange}
                      /> {errors.Technologies && (
                        <div className="invalid-feedback">
                          {errors.Technologies}
                        </div>
                      )}
                    </div>
                    <div className="col-2">
                      <label className="form-label">Fixed BID</label>
                      <div
                        className="d-flex align-items-center"
                        style={{ gap: "2px" }}
                      >
                        <div className="col-10">
                          <Select
                            name="FixedBid"
                            className={`${milestoneErrors?.Milestone || errors.projectmilestone ? "is-invalid" : ""}`}

                            onChange={(selectedOption, action) =>
                              handleSelectChange(selectedOption, action.name)
                            }
                            value={fixedBidOptions?.find(
                              (o) => o.value === formData?.FixedBid
                            )}
                            options={fixedBidOptions}
                            styles={{
                              control: (base) => ({ ...base, height: "38px" }),
                            }}
                          />

                          {(milestoneErrors?.Milestone || errors.projectmilestone) && (
                            <div className="invalid-feedback">
                              {milestoneErrors?.Milestone || errors.projectmilestone}
                            </div>
                          )}
                        </div>
                        <span className="col-2 text-center">
                          <button
                            id="Add-btn"
                            className="btn btn-primary "
                            disabled={formData?.FixedBid === 1 ? false : true}
                            style={{ height: "30px", width: "100%" }}
                            onClick={(e) => handleFixedBid(e)}
                          >
                            <i className="fa fa-plus"></i>
                          </button>
                        </span>
                      </div>
                    </div>

                    <div className="col-2">
                      <label className="form-label">
                        SOW/PO/SO<span className="text-danger">*</span>
                      </label>
                      <div
                        className="d-flex align-items-center"
                        style={{ gap: "2px" }}
                      >
                        <span className="col-2 text-center">
                          <button
                            id="Add-btn"
                            className="btn btn-primary"
                            style={{ height: "30px", width: "100%" }}
                            onClick={(e) => handleSowModal(e)}
                          >
                            <i className="fa fa-plus"></i>
                          </button>
                        </span>
                        <div className="col-10">
                          <input
                            type="text"
                            disabled
                            name="projectinvoice"
                            value={
                              formData?.projectinvoice?.length
                                ? formData.projectinvoice[
                                  formData.projectinvoice.length - 1
                                ].InvoiceNo
                                : null
                            }
                            className={`form-control ${errors.projectinvoice ? "is-invalid" : ""
                              }`}
                          />{" "}
                          {errors.projectinvoice && (
                            <div className="invalid-feedback">
                              {errors.projectinvoice}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-2">
                      <label className="form-label">Days/Month</label>
                      <input
                        type="text"
                        name="DaysOrMonth"
                        className="form-control"
                        value={formData?.DaysOrMonth}
                        onChange={(e) => handleChange(e)}
                      />
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col-2">
                      <label className="form-label">
                        Start Date<span className="text-danger">*</span>
                      </label>
                      <CustomDatePicker
                        // handleChange={(e) => handleChange(e)}
                        value={formData?.StartDate}
                        name="StartDate"
                        className={`form-control ${errors.StartDate ? "is-invalid" : ""
                          }`}
                        readOnly={true}
                        placeholderText="DD-MMM-YYYY"
                      />
                      {errors.StartDate && (
                        <div className="text-danger">{errors.StartDate}</div>
                      )}
                    </div>
                    <div className="col-2">
                      <label className="form-label">End Date</label>
                      <CustomDatePicker
                        handleChange={(e) => handleChange(e)}
                        value={formData?.EndDate}
                        name="EndDate"
                        readOnly={true}
                        className="form-control"
                        placeholderText="DD-MMM-YYYY"
                      />
                    </div>

                    <div className="col-2">
                      <label className="form-label">
                        Payment Terms<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className={` form-control ${errors.PaymentTerms ? "is-invalid" : ""
                          }`}
                        name="PaymentTerms"
                        value={formData?.PaymentTerms}
                        onChange={(e) => handleChange(e)}
                      />
                      {errors.PaymentTerms && (
                        <div className="invalid-feedback">
                          {errors.PaymentTerms}
                        </div>
                      )}
                    </div>
                    <div className="col-2">
                      <label className="form-label">PO Value
                        {/* {formData?.FixedBid?<span className="error">*</span>:null} */}
                      </label>
                      <input
                        type="text"
                        className={` form-control ${errors.POValue ? "is-invalid" : ""
                          }`} value={formData?.POValue}
                        name="POValue"
                        onChange={(e) => handleChange(e)}
                        disabled={!formData?.FixedBid}
                      />
                      {errors.POValue && (
                        <div className="invalid-feedback">{errors.POValue}</div>
                      )}
                    </div>
                    {/* <div className="col-2">
                      <label className="form-label">TnE Invoice</label>
                      <Select
                        options={tneInvoiceOptions}
                        name="TNEInvoice"
                        value={tneInvoiceOptions?.find(
                          (o) => o.TNEInvoice === formData?.TNEInvoice
                        )}
                        onChange={(selectedOption, action) =>
                          handleSelectChange(selectedOption, action.name)
                        }
                      />
                    </div> */}

                    <div className="col-2">
                      <label className="form-label">
                        Currency<span className="text-danger">*</span>
                      </label>
                      <Select
                        name="Currency"
                        className={` ${errors.Currency ? "is-invalid" : ""}`}
                        onChange={(selectedOption, action) =>
                          handleSelectChange(selectedOption, action.name)
                        }
                        value={currencyOptions?.find(
                          (o) => o.value === formData?.Currency
                        )}
                        options={currencyOptions}
                      />
                      {errors.Currency && (
                        <div className="invalid-feedback">
                          {errors.Currency}
                        </div>
                      )}
                    </div>
                    <div className="col-2">
                      <label className="form-label">Description</label>
                      <input
                        type="text"
                        className="form-control"
                        value={formData?.Description}
                        name="Description"
                        onChange={(e) => handleChange(e)}
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    {/* <div className="col-2">
                      <label className="form-label">Rate</label>
                      <input
                        type="text"
                        className="form-control text-end"
                        // value={}
                        name="Rate"
                        value={formData?.Rate}
                        onChange={(e) => handleChange(e)}
                        // disabled
                      />
                    </div> */}
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="d-flex justify-content-end align-items-end m-2  text-right">
                        <button
                          type="button"
                          className="cancel-btn  me-2"
                          onClick={() => navigate("/create-project")}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          onClick={handleSubmit}
                          className="custom-btn"
                          disabled={loading ? true : false}
                        >
                          {loading ? (
                            <FaSpinner class="sm-spinner" />
                          ) : (
                            "Submit"
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <Modal
        show={showFixedBidModal}
        onHide={handleFixedBidClose}
        dialogClassName="modal-xl"
        className="zoomable-div"
        centered
      >
        <div className="modal-content" style={{ borderRadius: '8px', zoom: 0.7 }}>
          <div
            className="modal-header"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              borderBottom: '1px solid #f0f0f0',
              backgroundColor: '#f8f9fa',
              borderRadius: '8px 8px 0 0',
              padding: '12px 16px'
            }}
          >
            <p style={{
              fontSize: '20px',
              fontWeight: '600',
              color: '#27568B',
              margin: '0'
            }}>Add MileStone details</p>
            <button
              onClick={handleFixedBidClose}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '18px',
                color: '#000',
                padding: '4px',
                borderRadius: '4px',
                transition: 'all 0.2s',
                lineHeight: '1'
              }}
            >
              <i className="bi bi-x-lg"></i>
            </button>
          </div>

          <div className="modal-body p-3" style={{ backgroundColor: 'white' }}>
            <div className="d-flex justify-content-end mb-3">
              <button
                type="button"
                onClick={handleFixedBidAddLine}
                className="custom-btn-sm"
                style={{ padding: '4px 12px' }}
              >
                <i className="fa fa-plus"></i>&nbsp;Add
              </button>
            </div>

            <div className="table-responsive">
              <Table bordered style={{ marginBottom: '0' }}>
                <thead style={{ backgroundColor: '#f8f9fa' }}>
                  <tr>
                    <th style={{ padding: '8px', width: '5%' }}>##</th>
                    <th style={{ padding: '8px' }}>
                      Milestone<span className="text-danger">*</span>
                    </th>
                    <th style={{ padding: '8px' }}>End Date</th>
                    <th style={{ padding: '8px' }}>Milestone Value</th>
                    <th style={{ padding: '8px' }}>Remarks</th>
                    <th style={{ padding: '8px', width: '5%' }}></th>
                  </tr>
                </thead>
                <tbody>
                  {fixesBidLines?.map((ele, index) => (
                    <tr key={index}>
                      <td style={{ padding: '8px' }}>{index + 1}</td>
                      <td style={{ padding: '8px' }}>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          name="Milestone"
                          value={ele?.Milestone}
                          onChange={(e) => handleMileStoneChange(e, index)}
                          style={{ minWidth: '150px' }}
                        />
                      </td>
                      <td style={{ padding: '8px' }}>
                        <CustomDatePicker
                          className="form-control form-control-sm"
                          name="EndDate"
                          value={ele?.EndDate}
                          placeholderText="DD-MMM-YYYY"
                          handleChange={(e) => handleMileStoneChange(e, index)}
                        />
                      </td>
                      <td style={{ padding: '8px' }}>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          name="MilestoneValue"
                          value={ele?.MilestoneValue}
                          onChange={(e) => handleMileStoneChange(e, index)}
                        />
                      </td>
                      <td style={{ padding: '8px' }}>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          name="Remarks"
                          value={ele?.Remarks}
                          onChange={(e) => handleMileStoneChange(e, index)}
                        />
                      </td>
                      <td style={{ padding: '8px', textAlign: 'center' }}>
                        <i
                          className="bi bi-trash icons"
                          onClick={() => handleDeleteMilestoneLine(index)}
                          style={{ cursor: 'pointer', color: '#000' }}
                        ></i>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            <div className="mt-2">
              {milestoneErrors?.Milestone && (
                <p className="text-danger" style={{ fontSize: '14px' }}>
                  Milestone Detail Entries: {milestoneErrors.Milestone}
                </p>
              )}
            </div>
          </div>

          <div style={{
            padding: '12px 16px',
            borderTop: '1px solid #f0f0f0',
            display: 'flex',
            justifyContent: 'flex-end'
          }}>
            <button
              className="cancel-btn me-2"
              onClick={handleFixedBidClose}
              style={{ padding: '4px 12px' }}
            >
              Cancel
            </button>
            <button
              disabled={loading ? true : false}
              className="custom-btn"
              onClick={addMilestoneToInvoice}
              style={{ padding: '4px 12px' }}
            >
              {loading ? <FaSpinner className="sm-spinner" /> : "Add"}
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        show={showSOWModal}
        onHide={handleSOWClose}
        dialogClassName="modal-xl"

        centered
      >
        <div className="modal-content" style={{ borderRadius: '8px', zoom: 0.7 }}>
          <div
            className="modal-header"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              borderBottom: '1px solid #f0f0f0',
              backgroundColor: '#f8f9fa',
              borderRadius: '8px 8px 0 0',
              padding: '12px 16px'
            }}
          >
            <p style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#2F2E4B',
              margin: '0'
            }}>Add Details</p>
            <button
              onClick={handleSOWClose}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '18px',
                color: '#000',
                padding: '4px',
                borderRadius: '4px',
                transition: 'all 0.2s',
                lineHeight: '1'
              }}
            >
              <i className="bi bi-x-lg"></i>
            </button>
          </div>

          <div className="modal-body p-3" style={{ backgroundColor: 'white' }}>
            <div className="d-flex justify-content-end mb-3">
              <button
                type="button"
                onClick={handleSowAddLine}
                className="custom-btn-sm"
                style={{ padding: '4px 12px' }}
              >
                <i className="fa fa-plus"></i>&nbsp;Add
              </button>
            </div>

            <div className="table-responsive" style={{ overflowX: "auto" }}>
              <Table bordered className="mb-0">
                <thead style={{ backgroundColor: '#f8f9fa' }}>
                  <tr>
                    <th style={{ minWidth: "40px", padding: '8px' }}>##</th>
                    <th style={{ minWidth: "150px", whiteSpace: "nowrap", padding: '8px' }}>
                      Type
                    </th>
                    <th style={{ minWidth: "300px", whiteSpace: "nowrap", padding: '8px' }}>
                      SOW/PO/SO<span className="text-danger">*</span>
                    </th>
                    <th style={{ minWidth: "160px", whiteSpace: "nowrap", padding: '8px' }}>
                      Start Date<span className="text-danger">*</span>
                    </th>
                    <th style={{ minWidth: "160px", whiteSpace: "nowrap", padding: '8px' }}>
                      End Date
                    </th>
                    <th style={{ minWidth: "120px", whiteSpace: "nowrap", padding: '8px' }}>
                      PO Value
                    </th>
                    <th style={{ minWidth: "120px", whiteSpace: "nowrap", padding: '8px' }}>
                      PO Balance
                    </th>
                    <th style={{ minWidth: "150px", whiteSpace: "nowrap", padding: '8px' }}>
                      Remarks
                    </th>
                    <th style={{ minWidth: "50px", padding: '8px' }}></th>
                  </tr>
                </thead>

                <tbody>
                  {sowLines?.map((ele, index) => (
                    <tr key={index}>
                      <td style={{ padding: '8px' }}>{index + 1}</td>

                      {/* Type Select */}
                      <td style={{ minWidth: "150px", padding: '8px' }}>
                        <Select
                          options={sowTypesOptions}
                          menuPortalTarget={document.body}
                          styles={{
                            control: (base) => ({
                              ...base,
                              minHeight: "32px",
                              fontSize: '14px'
                            }),
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          name="ProposalType"
                          value={sowTypesOptions?.find(
                            (o) => o.value === ele?.ProposalType
                          )}
                          onChange={(selectedOption, action) =>
                            handleProjectInvoiceSelectChange(
                              selectedOption,
                              action.name,
                              index
                            )
                          }
                        />
                      </td>

                      {/* Invoice No */}
                      <td style={{ minWidth: "150px", padding: '8px' }}>
                        <input
                          type="text"
                          className={`form-control form-control ${errors?.[`sowLines[${index}].InvoiceNo`]
                            ? "is-invalid"
                            : ""
                            }`}
                          name="InvoiceNo"
                          value={ele?.InvoiceNo}
                          onChange={(e) => handleProjectInvoiceChange(e, index)}
                        />
                        {errors?.[`sowLines[${index}].InvoiceNo`] && (
                          <div className="invalid-feedback d-block" style={{ fontSize: '12px' }}>
                            {errors[`sowLines[${index}].InvoiceNo`]}
                          </div>
                        )}
                      </td>

                      {/* Start Date */}
                      <td style={{ minWidth: "150px", padding: '8px' }}>
                        <CustomDatePicker
                          placeholderText="DD-MMM-YYYY"
                          name="StartDate"
                          className={`form-control form-control-sm ${errors?.[`sowLines[${index}].StartDate`]
                            ? "is-invalid"
                            : ""
                            }`}
                          value={ele?.StartDate}
                          handleChange={(date) =>
                            handleProjectInvoiceChange(date, index)
                          }
                        />
                        {errors?.[`sowLines[${index}].StartDate`] && (
                          <div className="invalid-feedback d-block" style={{ fontSize: '12px' }}>
                            {errors[`sowLines[${index}].StartDate`]}
                          </div>
                        )}
                      </td>

                      {/* End Date */}
                      <td style={{ minWidth: "150px", padding: '8px' }}>
                        <CustomDatePicker
                          placeholderText="DD-MMM-YYYY"
                          name="EndDate"
                          className="form-control form-control-sm"
                          value={ele?.EndDate}
                          handleChange={(date) =>
                            handleProjectInvoiceChange(date, index)
                          }
                          minDate={ele?.StartDate ? new Date(ele?.StartDate) : new Date()}
                        />
                      </td>

                      {/* PO Value */}
                      <td style={{ padding: '8px' }}>
                        <input
                          type="text"
                          className={`form-control form-control ${errors?.[`sowLines[${index}].SoPoValue`]
                            ? "is-invalid"
                            : ""
                            }`}
                          name="SoPoValue"
                          value={ele?.SoPoValue}
                          onChange={(e) => handleProjectInvoiceChange(e, index)}
                        />
                        {errors?.[`sowLines[${index}].SoPoValue`] && (
                          <div className="invalid-feedback d-block" style={{ fontSize: '12px' }}>
                            {errors[`sowLines[${index}].SoPoValue`]}
                          </div>
                        )}
                      </td>

                      {/* PO Balance */}
                      <td style={{ padding: '8px' }}>
                        <input
                          type="text"
                          className={`form-control form-control ${errors?.[`sowLines[${index}].SoPoBalance`]
                            ? "is-invalid"
                            : ""
                            }`}
                          name="SoPoBalance"
                          value={ele?.SoPoBalance}
                          onChange={(e) => handleProjectInvoiceChange(e, index)}
                        />
                        {errors?.[`sowLines[${index}].SoPoBalance`] && (
                          <div className="invalid-feedback d-block" style={{ fontSize: '12px' }}>
                            {errors[`sowLines[${index}].SoPoBalance`]}
                          </div>
                        )}
                      </td>

                      {/* Remarks */}
                      <td style={{ padding: '8px' }}>
                        <input
                          type="text"
                          className={`form-control form-control ${errors?.[`sowLines[${index}].SoPoRemark`]
                            ? "is-invalid"
                            : ""
                            }`}
                          name="SoPoRemark"
                          value={ele?.SoPoRemark}
                          onChange={(e) => handleProjectInvoiceChange(e, index)}
                        />
                        {errors?.[`sowLines[${index}].SoPoRemark`] && (
                          <div className="invalid-feedback d-block" style={{ fontSize: '12px' }}>
                            {errors[`sowLines[${index}].SoPoRemark`]}
                          </div>
                        )}
                      </td>

                      {/* Delete Button */}
                      <td style={{ padding: '8px', textAlign: 'center' }}>
                        <i
                          className="bi bi-trash icon"
                          onClick={() => handleDeleteLine(index)}
                          style={{ color: '#dc3545', fontSize: '16px' }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            <div className="mt-2">
              {sowErrors?.InvoiceNo && (
                <p className="text-danger" style={{ fontSize: '14px' }}>
                  Invoice Detail Entries: {sowErrors.InvoiceNo}
                </p>
              )}
              {sowErrors?.StartDate && (
                <p className="text-danger" style={{ fontSize: '14px' }}>
                  Invoice Detail Entries: {sowErrors.StartDate}
                </p>
              )}
            </div>
          </div>

          <div className="modal-footer" style={{
            padding: '12px 16px',
            borderTop: '1px solid #f0f0f0',
            display: 'flex',
            justifyContent: 'flex-end'
          }}>
            <button
              className="cancel-btn me-2"
              onClick={handleSOWClose}
              style={{ padding: '4px 12px' }}
            >
              Cancel
            </button>
            <button
              disabled={loading || sowLines.length === 0}
              className="custom-btn"
              onClick={AddSowToInvoice}
              style={{ padding: '4px 12px' }}
            >
              {loading ? <FaSpinner className="sm-spinner" /> : "Add"}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CreateProjectAdd;
